(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		if (!imagesWrapper) return;
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup');
		const secondSection = document.querySelector('.product-section + section');
		const footer = document.querySelector('footer');

		if (!stickyBar || !secondSection || !footer) {
			return;
		}

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const secondSectionMid = getOffset(secondSection);
		const footerTop = getOffset(footer);

		const handleScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;
			stickyBar.classList[activeOffset ? "add" : "remove"]('active');
		};

		handleScroll();
	};

	document.addEventListener('scroll', () => revealPopup());

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
})();

/* =========================================================
   Mobile counter — shows "current / total" over the image
   ========================================================= */
(function () {
	var mq = window.matchMedia("(max-width: 1099px)");
	var RETRY_MS = [120, 300, 650, 1100, 1800, 2600];

	function isPdp() {
		return (
			document.body.classList.contains("template-product") ||
			!!document.querySelector(".template-product .product")
		);
	}

	function getMobileGallery() {
		return document.querySelector(".pdp-gallery--mobile");
	}

	function getMobileSwiperEl(gallery) {
		if (!gallery) return null;
		return gallery.querySelector("[data-pdp-mobile-swiper]") || gallery.querySelector(".pdp-mobile-swiper");
	}

	function ensureCounterEl(gallery) {
		if (!gallery) return null;
		var el = gallery.querySelector("[data-pdp-mobile-counter]") || gallery.querySelector(".pdp-mobile-counter");
		if (!el) {
			el = document.createElement("div");
			el.className = "pdp-mobile-counter";
			el.setAttribute("data-pdp-mobile-counter", "");
			gallery.appendChild(el);
		} else {
			el.setAttribute("data-pdp-mobile-counter", "");
			if (!el.classList.contains("pdp-mobile-counter")) el.classList.add("pdp-mobile-counter");
		}
		if (!el.hasAttribute("data-hidden")) el.setAttribute("data-hidden", "true");
		return el;
	}

	function setCounter(el, current, total) {
		if (!el) return;
		if (!total || total <= 1) {
			el.textContent = "";
			el.setAttribute("data-hidden", "true");
			return;
		}
		var c = Math.max(1, Math.min(current || 1, total));
		el.textContent = c + " / " + total;
		el.setAttribute("data-hidden", "false");
	}

	function activeIndexByCenter(rootEl, slides) {
		if (!rootEl || !slides || !slides.length) return 0;
		var r = rootEl.getBoundingClientRect();
		var centerX = r.left + r.width / 2;
		var bestIdx = 0;
		var bestDist = Infinity;
		for (var i = 0; i < slides.length; i++) {
			var sr = slides[i].getBoundingClientRect();
			var slideCenter = sr.left + sr.width / 2;
			var dist = Math.abs(slideCenter - centerX);
			if (dist < bestDist) { bestDist = dist; bestIdx = i; }
		}
		return bestIdx;
	}

	function collectSlides(swiperEl) {
		if (!swiperEl) return [];
		var wrapper = swiperEl.querySelector(".swiper-wrapper") || swiperEl;
		var nodes = wrapper.querySelectorAll(".swiper-slide, .product__media-item, .pdp-mobile-media-item");
		var arr = Array.prototype.slice.call(nodes);
		var seen = Object.create(null);
		var out = [];
		for (var i = 0; i < arr.length; i++) {
			var id = arr[i].getAttribute("data-media-id") || ("__idx_" + i);
			if (seen[id]) continue;
			seen[id] = true;
			out.push(arr[i]);
		}
		return out;
	}

	function bindFallback(swiperEl, counterEl) {
		if (!swiperEl || !counterEl || swiperEl.__pdpFallbackBound) return;
		swiperEl.__pdpFallbackBound = true;

		var slides = collectSlides(swiperEl);

		function updateNow() {
			slides = collectSlides(swiperEl);
			var idx = activeIndexByCenter(swiperEl, slides);
			setCounter(counterEl, idx + 1, slides.length);
		}

		var ticking = false;
		function requestUpdate() {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function () { ticking = false; updateNow(); });
		}

		swiperEl.addEventListener("scroll", requestUpdate, { passive: true });
		swiperEl.addEventListener("touchend", requestUpdate, { passive: true });
		window.addEventListener("resize", requestUpdate, { passive: true });
		requestUpdate();
	}

	function bootOnce() {
		if (!isPdp() || !mq.matches) return;

		var gallery = getMobileGallery();
		if (!gallery) return;
		var swiperEl = getMobileSwiperEl(gallery);
		if (!swiperEl) return;

		var counterEl = ensureCounterEl(gallery);

		var sw = swiperEl.swiper;
		if (sw && !sw.__pdpCounterBound) {
			sw.__pdpCounterBound = true;
			function update() {
				var total = sw.slides ? sw.slides.length : 0;
				var idx = (typeof sw.realIndex === "number") ? sw.realIndex : (sw.activeIndex || 0);
				setCounter(counterEl, idx + 1, total);
			}
			if (typeof sw.on === "function") {
				sw.on("slideChange", update);
				sw.on("transitionEnd", update);
			}
			update();
		} else if (!sw) {
			bindFallback(swiperEl, counterEl);
		}
	}

	function scheduleRetries() {
		for (var i = 0; i < RETRY_MS.length; i++) {
			(function (ms) { setTimeout(bootOnce, ms); })(RETRY_MS[i]);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", function () { bootOnce(); scheduleRetries(); });
	} else {
		bootOnce();
		scheduleRetries();
	}

	document.addEventListener("shopify:section:load", function () { bootOnce(); scheduleRetries(); });

	try { mq.addEventListener("change", function () { setTimeout(bootOnce, 80); }); }
	catch (e) { mq.addListener(function () { setTimeout(bootOnce, 80); }); }
})();

/* =========================================================
   Click image to open fullscreen modal
   ========================================================= */
(function () {
	var dragState = { moved: false, x: 0, y: 0 };

	document.addEventListener("pointerdown", function (e) {
		dragState.moved = false;
		dragState.x = e.clientX;
		dragState.y = e.clientY;
	}, { passive: true });

	document.addEventListener("pointermove", function (e) {
		if (Math.abs(e.clientX - dragState.x) > 8 || Math.abs(e.clientY - dragState.y) > 8) {
			dragState.moved = true;
		}
	}, { passive: true });

	document.addEventListener("click", function (e) {
		if (dragState.moved) return;
		var item = e.target.closest(".template-product .product__media-item");
		if (!item) return;
		if (e.target.closest("button, a, input, select, textarea, label, video, model-viewer")) return;
		var btn = item.querySelector(".product__media-toggle");
		if (btn && typeof btn.click === "function") btn.click();
	});
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).off("click.alFloatedDropdown").on("click.alFloatedDropdown", function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

		const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

		const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(".product__description");
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector("pickup-availability");
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector("product-recommendations");
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => { advantage.remove(); });

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();

		/* ---- HOTFIX (2026-07-17) -----------------------------------------
		   This sticky "buy bar" only needs the variant picker + add-to-cart
		   button. Until now it silently kept the full media gallery (both
		   the mobile and desktop galleries, the zoom/lightbox modal, and
		   any <video> elements) in the HTML it fetches and re-injects on
		   every single PDP load - doubling image/video decode work and
		   network weight for something the visitor never sees rendered
		   here. Stripping it out removes that duplicate cost entirely. --- */
		const mobileGallery = this.productElement.querySelector(".pdp-gallery--mobile");
		if (mobileGallery) mobileGallery.remove();

		const desktopGallery = this.productElement.querySelector(".pdp-gallery--desktop");
		if (desktopGallery) desktopGallery.remove();

		const mediaModals = this.productElement.querySelectorAll(".product-media-modal");
		mediaModals.forEach((modal) => { modal.remove(); });

		const leftoverVideos = this.productElement.querySelectorAll("video");
		leftoverVideos.forEach((v) => { v.remove(); });
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);

/* =========================================================
   Swiper Initialization
   sliderInit, subSliderInit, popupSliderInit
   Called by update-slider.js
   ========================================================= */

if (typeof window.sliderInstance === 'undefined') { window.sliderInstance = null; }
if (typeof window.subSliderInstance === 'undefined') { window.subSliderInstance = null; }

if (typeof window.sliderDestroy !== 'function') {
  window.sliderDestroy = function () {
    if (window.sliderInstance && typeof window.sliderInstance.destroy === 'function') {
      window.sliderInstance.destroy(true, true);
      window.sliderInstance = null;
    }
  };
}

if (typeof window.subSliderDestroy !== 'function') {
  window.subSliderDestroy = function () {
    if (window.subSliderInstance && typeof window.subSliderInstance.destroy === 'function') {
      window.subSliderInstance.destroy(true, true);
      window.subSliderInstance = null;
    }
  };
}

if (typeof window.subSliderInit !== 'function') {
  window.subSliderInit = function (force) {
    var el = document.querySelector('.pdp-gallery--desktop .product__media-sublist.swiper, .main-product-desktop-section-wrapper .product__media-sublist.swiper');
    if (!el) return;

    if (el.swiper && !force) return;
    if (el.swiper) { el.swiper.destroy(true, true); }

    var direction = el.getAttribute('data-direction') || 'vertical';

    try {
      window.subSliderInstance = new Swiper(el, {
        direction: direction === 'horizontal' ? 'horizontal' : 'vertical',
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        freeMode: true,
        slideToClickedSlide: true,
      });
    } catch (e) {
      console.warn('subSliderInit error:', e);
    }

    window.sliderInit(true);
  };
}

if (typeof window.sliderInit !== 'function') {
  window.sliderInit = function (force) {
    var el = document.querySelector('.pdp-gallery--desktop .product__media-list.swiper, .main-product-desktop-section-wrapper .product__media-list.swiper');
    if (!el) return;

    if (el.swiper && !force) return;
    if (el.swiper) { el.swiper.destroy(true, true); }

    var galleryType = el.getAttribute('data-gallery-type') || 'thumbs_aside';
    var direction = el.getAttribute('data-direction') || 'horizontal';

    var thumbsEl = document.querySelector('.pdp-gallery--desktop .product__media-sublist.swiper, .main-product-desktop-section-wrapper .product__media-sublist.swiper');
    var thumbsSwiper = thumbsEl && thumbsEl.swiper ? thumbsEl.swiper : null;

    var config = {
      direction: direction === 'vertical' ? 'vertical' : 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      watchSlidesProgress: true,
      grabCursor: true,
      keyboard: { enabled: true },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      on: {
        slideChange: function () {
          var activeSlide = this.slides[this.activeIndex];
          if (!activeSlide) return;
          var video = activeSlide.querySelector('video');
          if (video) {
            video.muted = true;
            video.play().catch(function () {});
          }
          document.querySelectorAll('.product__media-list .product__media-item video').forEach(function (v) {
            if (!activeSlide.contains(v)) v.pause();
          });
        }
      }
    };

    if (galleryType === 'static_multicolumns_aside') {
      config.slidesPerView = 2;
      config.spaceBetween = 8;
      config.direction = 'horizontal';
    }

    try {
      window.sliderInstance = new Swiper(el, config);
    } catch (e) {
      console.warn('sliderInit error:', e);
    }
  };
}

if (typeof window.popupSliderInit !== 'function') {
  window.popupSliderInit = function (force) {
    // Popup modal uses its own scroll — no Swiper needed
  };
}

/* =========================================================
   HOTFIX (2026-07-17): carry the currently-selected option
   (e.g. Size) across a PDP color-swatch click.

   Colors on this theme are separate PRODUCTS linked via a
   metafield and rendered as plain <a class="combined-color-swatch">
   links (see snippets/main-product-section.liquid). Clicking one
   is a full page navigation to a different product, so any Size
   already selected on the current page was previously lost.

   This intercepts that click, reads the currently-checked radio
   inputs on the product form (skipping the color/product-link
   option itself), and forwards them as query params on the
   destination URL. On load, it reads those same query params and
   pre-checks the matching radio on the destination page, so Size
   (or any other still-relevant option) carries over.
   ========================================================= */
(function () {
	function isPdp() {
		return (
			document.body.classList.contains("template-product") ||
			!!document.querySelector(".template-product .product")
		);
	}

	/* HOTFIX v3 (2026-07-17): registered on the CAPTURE phase + calls
	   stopImmediatePropagation(). Diagnostics proved this handler was
	   correctly computing and assigning the carry-over URL (confirmed
	   via sessionStorage instrumentation - the built URL was right every
	   time), but some other bubble-phase click handler on this theme
	   was still winning the actual navigation afterward, sending the
	   browser to its own (differently-built) destination instead.
	   Running in capture phase guarantees this listener sees the click
	   first, and stopImmediatePropagation stops that other handler from
	   running at all for this click, so our navigation is the only one
	   that fires. */
	document.addEventListener("click", function (e) {
		if (!isPdp()) return;
		var swatch = e.target.closest(".combined-color-swatch");
		if (!swatch || !swatch.getAttribute("href")) return;

		var params = new URLSearchParams();
		document
			.querySelectorAll('.product-form__controls-group input[type="radio"]:checked, product-form input[type="radio"]:checked')
			.forEach(function (input) {
				if (!input.name) return;
				var optionName = input.name.split("-")[0];
				if (!optionName || optionName.toLowerCase() === "color" || optionName.toLowerCase() === "colour") return;
				params.set(optionName, input.value);
			});

		if (![...params.keys()].length) return;

		try {
			var url = new URL(swatch.href, window.location.origin);
			params.forEach(function (value, key) { url.searchParams.set(key, value); });
			e.preventDefault();
			e.stopImmediatePropagation();
			window.location.href = url.toString();
		} catch (err) {
			// If URL parsing fails for any reason, fall back to the
			// swatch's default native navigation behaviour.
		}
	}, true);

	function preselectFromQueryString() {
		if (!isPdp()) return;
		var qs = new URLSearchParams(window.location.search);
		qs.forEach(function (value, key) {
			if (!value || key.toLowerCase() === "variant") return;
			document
				.querySelectorAll('input[type="radio"][name="' + key + '"], input[type="radio"][name^="' + key + '-"]')
				.forEach(function (input) {
					if (input.value === value && !input.checked) {
						input.checked = true;
						input.dispatchEvent(new Event("change", { bubbles: true }));
					}
				});
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", preselectFromQueryString);
	} else {
		preselectFromQueryString();
	}
	document.addEventListener("shopify:section:load", preselectFromQueryString);
})();

/* ---------------------------------------------------------------------
   HOTFIX (2026-07-17): price not updating on variant/size change
   -----------------------------------------------------------------------
   This theme renders the main product info block TWICE per product page
   (once per gallery layout - see main-product.liquid's two
   {% render 'main-product-section' %} calls), and only ONE copy is ever
   shown at a time (the other is hidden via CSS depending on viewport
   width). Both copies share the exact same element ids, including the
   price block (id="price-<section-id>").

   Shopify's native variant-change handler (assets/global.js,
   VariantSelects.renderProductInfo) looks up the price block with
   document.getElementById(...), which always returns the FIRST matching
   element in DOM order - regardless of which of the two duplicate copies
   is actually visible to the shopper. So on any product where different
   options/sizes have different prices, the visible price can get stuck
   on the old value after switching size, while the hidden duplicate
   silently receives the correct updated price.

   Fix: watch the copy that Shopify's native code actually updates, and
   mirror any change into the other duplicate(s) sharing the same id.
   This doesn't touch global.js or the native fetch/render logic at all -
   it just keeps every copy of the price block in sync so whichever one
   is visible always shows the right price. */
(function () {
	function syncDuplicatePriceBlocks() {
		var groups = {};
		document.querySelectorAll('[id^="price-"]').forEach(function (el) {
			(groups[el.id] = groups[el.id] || []).push(el);
		});

		Object.keys(groups).forEach(function (id) {
			var group = groups[id];
			if (group.length < 2) return;

			var source = group[0];
			var observer = new MutationObserver(function () {
				for (var i = 1; i < group.length; i++) {
					if (group[i].innerHTML !== source.innerHTML) {
						group[i].innerHTML = source.innerHTML;
					}
				}
			});
			observer.observe(source, { childList: true, subtree: true, characterData: true });
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", syncDuplicatePriceBlocks);
	} else {
		syncDuplicatePriceBlocks();
	}
	// Re-run after Theme Editor section reloads, since the duplicate
	// blocks (and their ids) are re-created from scratch each time.
	document.addEventListener("shopify:section:load", syncDuplicatePriceBlocks);
})();
